/* Store za obvestila ("kaj je novega").
   [PATCH objave-fe v1]

   Interno ime je "objave", ker je /obvestila zaseden za zvonec
   (obvestilaStore.ts + ObvestilaZvonec.tsx = nove listine po podjetjih).
   Ta store se zvonca in napakeStore NE dotika — to so trije locen kanali.

   Znacka je BOOLEAN, ne stevilo: zahteva je samo pikica, brez stetja. */
import { create } from 'zustand';
import { api } from '../lib/api';

interface ObjaveState {
  neprebrano: boolean;
  jeSuperadmin: boolean;
  nalozi: () => Promise<void>;
  oznaciPrebrano: () => Promise<void>;
}

export const useObjaveStore = create<ObjaveState>((set) => ({
  neprebrano: false,
  jeSuperadmin: false,
  nalozi: async () => {
    try {
      const r = await api.get('/objave/stevec');
      const d = r.data || {};
      set({ neprebrano: !!d.neprebrano, jeSuperadmin: !!d.je_superadmin });
    } catch {
      /* tiho — naslednja anketa poskusi znova */
    }
  },
  oznaciPrebrano: async () => {
    try {
      await api.post('/objave/videno', {});
      set({ neprebrano: false });
    } catch {
      /* tiho — pika ostane, naslednji obisk poskusi znova */
    }
  },
}));
